<script setup>
import { ref, onMounted } from "vue";
import { fetchGuidelineLink, updateGuidelineLink } from "./api";

const link = ref("");
const guidelineFile = ref(null);
const loading = ref(false);
const saving = ref(false);
const error = ref("");
const success = ref(false);

onMounted(async () => {
  loading.value = true;
  try { link.value = await fetchGuidelineLink(); }
  catch { error.value = "Couldn't load guideline link."; }
  finally { loading.value = false; }
});

async function save() {
  saving.value = true; error.value = ""; success.value = false;
  try { await updateGuidelineLink(link.value); success.value = true; }
  catch { error.value = "Couldn't save. Please try again."; }
  finally { saving.value = false; }
}
</script>

<template>
  <section>
    <h1 class="text-h5 mb-4">Stamp Guideline</h1>
    <p v-if="loading">Loading…</p>
    <VCard v-else class="pa-4" max-width="600">
      <VAlert v-if="error" type="error" class="mb-4">{{ error }}</VAlert>
      <VAlert v-if="success" type="success" class="mb-4">Saved.</VAlert>
      <VTextField v-model="link" label="Guideline Link (URL)" class="mb-4" />
      <VFileInput
        v-model="guidelineFile"
        label="Upload Guideline File (PDF / Image)"
        accept=".pdf,image/*"
        class="mb-4"
        prepend-icon=""
        prepend-inner-icon="ri-upload-line"
        hint="Optional — upload a file to replace the link above"
        persistent-hint
      />
      <VBtn :loading="saving" @click="save">Save</VBtn>
    </VCard>
  </section>
</template>
